import { Link } from 'react-router-dom';
import GoatPortrait from '../../assets/img/GoatPortrait.jpg';
import HeroCattle from '../../assets/img/HeroCattle.jpg';
import PawDark from '../../assets/svg/VeterinaryPawDark.svg';
import BuildingsWhite from '../../assets/svg/BuildingsWhite.svg';
import PawPrint from '../../assets/svg/PawPrint.svg';
import BriefcasePaw from '../../assets/svg/BriefcasePaw.svg';
import ArrowUpRight from '../../assets/svg/ArrowUpRight.svg';
import HoverZoomImage from '../motion/HoverZoomImage';

// Cards from Figma "Single Source of Truth" (1140:27735). "Read More" cards
// open the matching Facilities & Services tab; "Visit" cards open the
// partner platform's page.
const CARDS = {
  veterinary: {
    icon: PawDark,
    action: 'Read More',
    to: 'facilities-services',
    state: { topTab: 'stations' },
    title: 'Registered Veterinary',
    body: 'Every registered facility listed here is authorized, accredited, and officially recognized veterinary centers.',
    tone: 'bg-[rgba(217,251,212,0.5)] text-black',
    bodyWidth: 'max-w-[244px]',
  },
  fmld: {
    icon: BuildingsWhite,
    action: 'Read More',
    to: 'facilities-services',
    state: { topTab: 'fmld' },
    title: 'FMLD-Built Facilities',
    body: 'Every registered facility listed here is authorized, accredited, and officially recognized veterinary centers.',
    tone: 'bg-[#0f3a26] text-[#f1f4f9]',
    bodyWidth: 'max-w-[233px]',
  },
  nadis: {
    icon: PawPrint,
    action: 'Visit',
    to: 'nadis',
    title: 'National Animal Disease Information and Surveillance (NADIS)',
    body: "Nigeria's official platform for the collection, validation, and publication of animal disease data.",
    tone: 'bg-[rgba(217,251,212,0.6)] text-black',
    // Figma's text box is 244px — 13px wider than the card's content area,
    // running into the right padding — which keeps it to three lines
    bodyWidth: 'max-w-[244px] pub-xl:w-[244px] pub-xl:max-w-none',
  },
  naits: {
    icon: BriefcasePaw,
    action: 'Visit',
    to: 'naits',
    title: 'National Animal Identification and Traceability System (NAITS)',
    body: 'A holistic animal information management platform developed by the Federal Ministry of Agriculture and Food Security in partnership with the Department of Animal Husbandry Services and the Department of Animal Health.',
    tone: 'bg-[#d9fbd4] text-black',
    bodyWidth: 'max-w-[439px]',
  },
};

function InfoCard({ card, className = '' }) {
  const { icon, action, to, state, title, body, tone, bodyWidth } = CARDS[card];

  return (
    <div className={`flex min-h-[279px] flex-col justify-between gap-8 overflow-hidden rounded-xl px-[25px] py-[22px] ${tone} ${className}`}>
      <div className="flex items-start justify-between">
        <img src={icon} alt="" width="32" height="32" className="h-8 w-8" />
        <Link
          to={to}
          state={state}
          className="flex items-center gap-1 rounded-[4px] bg-[#1fc16b] p-[10px] text-[12px] leading-none text-[#d9fbd4] transition hover:bg-[#19a95c]"
        >
          {action}
          <img src={ArrowUpRight} alt="" width="12" height="12" className="h-3 w-3" />
        </Link>
      </div>

      <div className="flex flex-col gap-6">
        <h3 className="font-quattrocento text-[20px] font-bold leading-[1.1]">{title}</h3>
        <p className={`text-[15px] leading-normal ${bodyWidth}`}>{body}</p>
      </div>
    </div>
  );
}

// Wrapper stretches with its grid row; the image zooms inside it on hover
function Photo({ src, className = '' }) {
  return <HoverZoomImage src={src} className={`w-full rounded-xl ${className}`} />;
}

export default function VeterinaryFacilitiesSection() {
  return (
    <section className="bg-white py-10 sm:py-14 lg:py-16">
      <div className="mx-auto flex max-w-[1440px] flex-col gap-8 px-4 sm:px-8 lg:gap-16 lg:px-10 pub-xl:px-[100px]">

        <div className="flex flex-col gap-2">
          <h2 className="font-quattrocento text-2xl font-bold text-[#0f3a26] sm:text-3xl lg:text-[32px]">
            NLIMS - Livestock Information Single Source of Truth
          </h2>
          <p className="text-sm text-[#0f3a26] sm:text-base lg:text-[18px]">
            Explore how the numbers of processing facilities across different categories in Nigeria.
          </p>
        </div>

        {/* Figma column widths 305 / 391 / 497 with 24px gaps */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-[305fr_391fr_497fr]">
          {/* All three columns share the row height (as in Figma, 279 + 24 +
              279 = 582px): cards grow equally (flex-1) when any text runs
              longer, so every card's bottom edge lines up with the photo's.
              Left: the dark FMLD card is narrower (281px), left-aligned. */}
          <div className="flex flex-col items-start gap-6">
            <InfoCard card="veterinary" className="w-full flex-1" />
            <InfoCard card="fmld" className="w-full flex-1 pub-xl:w-[281px]" />
          </div>

          <Photo src={GoatPortrait} className="h-[360px] md:h-auto md:min-h-[582px]" />

          <div className="flex flex-col gap-6 md:col-span-2 lg:col-span-1">
            <div className="grid flex-1 grid-cols-1 gap-6 sm:grid-cols-[281fr_192fr]">
              <InfoCard card="nadis" />
              <Photo src={HeroCattle} className="h-[279px] sm:h-auto" />
            </div>
            <InfoCard card="naits" className="flex-1" />
          </div>
        </div>

      </div>
    </section>
  );
}
